import { authorizedAxiosInstance } from '../instances/AuthorizedAxiosInstance';

export interface PlacePurchaseOrderRequest {
    orderId: string;
    offerId: string;
}

export const placePurchaseOrder = async ({ orderId, offerId }: PlacePurchaseOrderRequest): Promise<void> => {
    await authorizedAxiosInstance.post('/v1/mariapps/place-purchase-order', undefined, {
        params: { orderId, offerId },
    });
};

export interface LinkPurchaseOrderRequest {
    orderId: string;
    offerId: string;
    poNumber: string;
}

export interface LinkPurchaseOrderResponse {
    message: string;
    orderId: string;
    offerId: string;
    poNumber: string;
}

export const linkPurchaseOrder = async (request: LinkPurchaseOrderRequest): Promise<LinkPurchaseOrderResponse> => {
    const response = await authorizedAxiosInstance.post<LinkPurchaseOrderResponse>(
        '/v1/mariapps/link-purchase-order',
        request
    );
    return response.data;
};

export const updatePurchaseOrder = async (offerId: string): Promise<void> => {
    await authorizedAxiosInstance.post('/v1/mariapps/update-purchase-order', undefined, {
        params: { offerId },
    });
};

export interface ImportRequisitionRequest {
    groupId: string;
    requisitionNumber: string;
}

export const importRequisition = async ({ groupId, requisitionNumber }: ImportRequisitionRequest): Promise<void> => {
    await authorizedAxiosInstance.post('/v1/mariapps/import-requisition', undefined, {
        params: { groupId, requisitionNumber },
    });
};

export interface CancelRequisitionRequest {
    enquiryId: string;
    userId: string;
    dateCanceled: Date;
}

export const cancelRequisition = async ({
    enquiryId,
    userId,
    dateCanceled,
}: CancelRequisitionRequest): Promise<void> => {
    await authorizedAxiosInstance.post('/v1/mariapps/cancel-requisition', undefined, {
        params: {
            enquiryId,
            userId,
            dateCanceled: dateCanceled.toISOString(),
        },
    });
};

export interface FailedRequisitionImport {
    id: string;
    requisitionNumber: string;
    customerGroupId: string;
    failureReason: string;
    errorMessage: string;
    retryable: boolean;
    retryCount: number;
    lastRetryDate: string | null;
    createdDate: string;
}

interface GetFailedRequisitionsResponse {
    failedRequisitions: FailedRequisitionImport[];
}

export const getFailedRequisitions = async (groupId?: string): Promise<GetFailedRequisitionsResponse> => {
    const response = await authorizedAxiosInstance.get<GetFailedRequisitionsResponse>(
        '/v1/mariapps/failed-requisitions',
        { params: { groupId } }
    );
    return response.data;
};

export const deleteFailedRequisition = async (id: string): Promise<void> => {
    await authorizedAxiosInstance.delete(`/v1/mariapps/failed-requisitions/${id}`);
};

export const markFailedRequisitionNonRetryable = async (id: string): Promise<void> => {
    await authorizedAxiosInstance.post(`/v1/mariapps/failed-requisitions/${id}/mark-non-retryable`);
};
